// Vendor
import $ from 'jquery';
import TweenMax from 'gsap';
import 'gsap/ScrollToPlugin';

// Modules
import StickyNav from '../modules/sticky-nav';

// Element
let $el = $('body.vaccine-disease-article');
let $sticky = $('.js-sticky-nav');

class VaccineDisease {
	constructor($el) {
		this.$el = $el;
		this.$nav = $el.find('.vaccine-disease-nav');
		this.$items = $el.find('.vaccine-disease-nav-list li a');
		this.$body = $el.find('.article-body');
		this.$sections = $el.find('[data-scroll]');

		// Mobile Nav
		this.render();
		this.attachEvents();
	}

	attachEvents() {
		this.$items.on('click', (evt) => {
			evt.preventDefault();
			let currentTarget = $(evt.currentTarget);
			if (currentTarget.length) {
				let target = $(evt.currentTarget).attr('href').split('#')[1];
				this.scrollToElement(target);
			}
		});

		this.$dropdown.on('change', (evt) => {
			let currentTarget = $(evt.currentTarget);
			if (currentTarget.length) {
				let target = $(evt.currentTarget).val().split('#')[1];
				this.scrollToElement(target);
			}
		});

	}

	scrollToElement(target) {
		let offset = (window.innerWidth > 1024) ? 145 : 114;
		let $target = $(`[data-scroll="${target}"]`);

		// check if scrolling upward or downward


		if ($target.length) {
			let y = $target.offset().top - offset;
			TweenMax.to($(window), 0.8, { scrollTo: { y: y, autoKill: false }});
		}
	}

	render() {
		let $items = $.makeArray(this.$items);
		let $select = $(`
			<div class="vaccine-disease-nav-dropdown mobile-dropdown">
				<select>
					${$items.map((v) => `
						<option value="${$(v).attr('href')}">
							${$(v).text()}
						</option>
					`.trim()).join('')}
				</select>
			</div>
		`);
		$select.insertAfter(this.$nav);
		this.$dropdown = $select.find('select');
	}
}

const _init = () => {
	if ($el.length) {
		let vac = new VaccineDisease($el);
		new StickyNav($sticky, {
			$targetY: vac.$body,
			$sections: vac.$sections
		});
	}
};


_init();